import { AppRoute } from 'app/app-layout/constants/index';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondary } from 'app/app-layout/models/nav/nav-item-secondary.model';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';

export class UsersNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: '$nav_primary_users',
      categoryId: NavCategoryId.USERS,
      categoryIcon: 'ico-nav-users.svg',
      route: AppRoute.users,
      menuItems: [
        new SystemUsersNavItem(),
      ],
    });
  }
}

export class SystemUsersNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$users_system_users_nav_secondary_dashboard',
      scopes: [
        AppScopes.EMPLOYEE_ACTIONS,
        AppScopes.USER_PROFILE,
        AppScopes.PROFILE_EDIT,
        AppScopes.CASE_MANAGEMENT_MASTER,
        AppScopes.ERGO_WORKFLOW,
        AppScopes.ERGO_TEAM_MANAGEMENT,
        AppScopes.ROLE_PERMISSION,
      ],
      route: AppRoute.systemUsers,
      categoryId: NavCategoryId.USERS,
    });
  }
}
